import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-stackBase",
  "use": "icon-stackBase-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-stackBase\">\n<rect x=\"22.475\" y=\"22.475\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"none\" stroke=\"#F08300\" stroke-width=\"7.238\" stroke-miterlimit=\"22.9256\" width=\"155.051\" height=\"155.051\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol